import { ApiPromptMeta, ApiPromptMetaListResponse, ApiPromptsListParams, Langfuse, LangfuseOptions } from 'langfuse';
import { ChatMessage, ChatPromptClient, TextPromptClient } from 'langfuse-core';
import { from, map, Observable } from 'rxjs';
import { LANGFUSE_LATEST_LABEL } from '../constants/langfuse.constants';

export class LangFuseService {
  readonly langfuse: Langfuse;
  readonly promptCacheSeconds = 600; // 10 minutes

  constructor(private readonly options: LangfuseOptions) {
    this.langfuse = new Langfuse(this.options);
  }

  getTextPrompt(
    id: string,
    fallback: string,
    label?: string | null,
  ): Observable<TextPromptClient> {
    return from(
      this.langfuse.getPrompt(id, undefined, {
        label: label ?? LANGFUSE_LATEST_LABEL,
        fallback,
        type: 'text',
        cacheTtlSeconds: this.promptCacheSeconds,
      }),
    ).pipe(map((client) => client));
  }

  getChatPrompt(
    id: string,
    fallback: ChatMessage[],
    label?: string,
  ): Observable<ChatPromptClient> {
    return from(
      this.langfuse.getPrompt(id, undefined, {
        label,
        fallback,
        type: 'chat',
        cacheTtlSeconds: this.promptCacheSeconds,
      }),
    ).pipe(map((client) => client));
  }

  listAllPrompts(
    params: ApiPromptsListParams = { page: 1, limit: 100, label: null, tag: null }
  ): Observable<ApiPromptMeta[]> {
    return from(
      this.langfuse.api.promptsList(params)
    ).pipe(map((response: ApiPromptMetaListResponse) => response.data));
  }
}
